<template>
  <v-container fluid grid-list-lg class="pa-2" :style="{ width: '100% !important' }">
    <v-layout wrap>
      <v-flex d-flex xs12 md6>
        <slot name="chart"></slot>
      </v-flex>
      <v-flex d-flex xs12 md6>
        <v-layout wrap>
          <v-flex d-flex xs12>
            <slot name="newComment"></slot>
          </v-flex>
          <v-flex d-flex xs12>
            <slot name="hideReplyComment"></slot>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  methods: {
    handleSearchButtonClick() {
      this.$emit('search')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/ReplyComment/Overview.vue